import React from 'react';
import styled from '@emotion/styled';

import { Typography } from '@mui/material';

import SidebarNavList from './SidebarNavList';
import { SidebarItemPageOptions } from './types';

const Title = styled(Typography)`
  color: ${(props) => props.theme.sidebar.color};
  font-size: ${(props) => props.theme.typography.caption.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  padding: ${(props) => props.theme.spacing(4)}
    ${(props) => props.theme.spacing(6)} ${(props) => props.theme.spacing(1)};
  opacity: 0.4;
  text-transform: uppercase;
  display: block;
`;

interface SidebarNavSectionProps {
  title?: string;
  pages: SidebarItemPageOptions[];
  className?: string;
  component?: any;
}

const SidebarNavSection = (props: SidebarNavSectionProps) => {
  const {
    title,
    pages,
    className,
    component: Component = 'nav',
    ...rest
  } = props;

  return (
    <Component {...rest}>
      {title && <Title variant="subtitle2">{title}</Title>}
      <SidebarNavList pages={pages} depth={0} />
    </Component>
  );
};

export default SidebarNavSection;
